import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, BehaviorSubject, of } from "rxjs";
import { FindCompteOperateurOutputVO } from "../../models/FindCompteOperateursOutputVO";
import { AbstractService } from "../abstract.service";
import { SaveCompteOperateurInputVO } from "../../models/SaveCompteOperateurInputVO";
import { SaveCompteOperateurOutputVO } from "../../models/SaveCompteOperateurOutputVO";
import { environment } from "src/environments/environment";
import { GenericHttpClient } from "../generic-http-client";

@Injectable({ providedIn: "root" })
export class CompteOperateurService extends AbstractService {
  public CER_API =
    environment.SERVER_URL + "compteOperateur/public/authenticate";
  public flagNotif = environment.SERVER_URL + "alert/public/markAlertAsRead";
  public searchHistorique =
    environment.SERVER_URL + "alert/public/getUnreadAlertByOperateur";
  public COS_API = environment.SERVER_URL + "compteOperateur/public/save";
  public COE_API = environment.SERVER_URL + "compteOperateur/public/existence";
  public COESCS_API = environment.SERVER_URL + "compteOperateur/public/existence/scs";
  public COC_API = environment.SERVER_URL + "compteOperateur/public/complement";
  public URL_GET_LIST_COMPTE_OPERATEUR_STRUCTURE =
    environment.SERVER_URL +
    "compteOperateur/public/compteOperateurByStructure";
  public ID_INTERNE =
    environment.SERVER_URL + "compteOperateur/public/getIdIntene";
  public OPE_SESSION =
    environment.SERVER_URL + "compteOperateur/public/getOpeSession";
      public CER_MFA_API =
    environment.SERVER_URL + "compteOperateur/public/generate-mfa";

  public OPE_CREDIT_ENLEVEMENT =
    environment.SERVER_URL + "compteOperateur/public/creditEnlevement";
  public COU_API = environment.SERVER_URL + "compteOperateur/public/update";
  public COA_API = environment.SERVER_URL + "compteOperateur/public/active";
  public UPDATE_PASSWORD_API =
    environment.SERVER_URL + "compteOperateur/public/updatePassword";
  public UPDATE_PASSWORDP_API =
    environment.SERVER_URL + "compteOperateur/public/updatePasswordProfil";

  public USER_FORGET_PSW =
    environment.SERVER_URL + "compteOperateur/public/forgetPsw";
  public USER_FORGET_PSW_CKECK =
    environment.SERVER_URL + "compteOperateur/public/forgetPswCheck";
  public GERANT_API = environment.SERVER_URL + "gerant/listGerantOfOperateur";
  public URL_GET_COMPTE_OPERATEUR_ICE =
    environment.SERVER_URL + "compteOperateur/public/findCompteOperateurByIce";
  public CONTACT_API =
    environment.SERVER_URL + "compteOperateur/public/contacterConseiller";
  public ASC_API =
    environment.SERVER_URL + "compteOperateur/public/addSousCompte";
  public ASCS_API =
    environment.SERVER_URL + "compteOperateur/public/addSousCompteSimplifie";
  public RSC_API =
    environment.SERVER_URL + "compteOperateur/public/deleteSousCompte";
  public DSC_API =
    environment.SERVER_URL + "compteOperateur/public/disableSousCompteSimplifie";
  public ESCS_API =
    environment.SERVER_URL + "compteOperateur/public/editSousCompteSimplifie";
  public CSC_API =
    environment.SERVER_URL + "compteOperateur/public/confirmSousCompte";
  public AJSC_API =
    environment.SERVER_URL + "compteOperateur/public/askJoiningAsSousCompte";

  compteOperateur: any = null;

  gerants: any[] = null;

  private compteOperateurSource = new BehaviorSubject(this.compteOperateur);
  currentcompteOperateurSource = this.compteOperateurSource.asObservable();

  private gerantsSource = new BehaviorSubject(this.gerants);
  currentGerants = this.gerantsSource.asObservable();

  constructor(private http: GenericHttpClient) {
    super();
  }

  getAll(): Observable<any> {
    return this.http.httpGet(environment.SERVER_URL + "certificat/get");
  }

  get(id: string) {
    return this.http.httpGet(this.CER_API + "/" + id);
  }

  logout(): Observable<any> {
    return this.http.httpGet(
      environment.SERVER_URL + "compteOperateur/public/logout"
    );
  }

  addSousCompte(input: any): Observable<any> {
    return this.http.httpPost(this.ASC_API, input);
  }

  addSousCompteSimplifie(input: any): Observable<any> {
    return this.http.httpPost(this.ASCS_API, input);
  }

  retirerSousCompte(input: any): Observable<any> {
    return this.http.httpPost(this.RSC_API, input);
  }

  desactiverSousCompteSimplifie(input: any): Observable<any> {
    return this.http.httpPost(this.DSC_API, input);
  }

  editerRolesSousCompteSimplifie(input: any): Observable<any> {
    return this.http.httpPost(this.ESCS_API, input);
  }

  confirmerSousCompte(input: any): Observable<any> {
    return this.http.httpPost(this.CSC_API, input);
  }

  askJoiningAsSousCompte(input: any): Observable<any> {
    return this.http.httpPost(this.AJSC_API, input);
  }

  findCompteOperateur(compteOperateur: any): Observable<any> {
    return this.http.httpPost(this.CER_API, compteOperateur);
  }

  findIdInterneOperateur(compteOperateur: any): Observable<any> {
    return this.http.httpPost(this.ID_INTERNE, compteOperateur);
  }

  contact(params): Observable<any> {
    return this.http.httpPost(this.CONTACT_API, params);
  }

  findOperateurByIce(ice: string): Observable<any> {
    return this.http.httpGet(this.URL_GET_COMPTE_OPERATEUR_ICE + "/" + ice);
  }

  findOpeSession(compteOperateur: any): Observable<any> {
    return this.http.httpPost(this.OPE_SESSION, compteOperateur);
  }

  getCreditEnlevement(compteOperateur: any): Observable<any> {
    return this.http.httpPost(this.OPE_CREDIT_ENLEVEMENT, compteOperateur);
  }

  forgetPsw(user: any): Observable<any> {
    return this.http.httpPost(this.USER_FORGET_PSW, user);
  }

  forgetPswCheck(user: any): Observable<any> {
    return this.http.httpPost(this.USER_FORGET_PSW_CKECK, user);
  }

  getInvalideCompteOperateurByStructure(
    codeStructure: string
  ): Promise<FindCompteOperateurOutputVO> {
    return this.http
      .httpGet(
        this.URL_GET_LIST_COMPTE_OPERATEUR_STRUCTURE + "/" + codeStructure
      )
      .toPromise()
      .then((response) => response as FindCompteOperateurOutputVO)
      .catch(this.handleError);
  }

  getGerantsByOperateur(idOperateur: any): Observable<any> {
    return this.http.httpPost(this.GERANT_API, idOperateur);
  }

  setCompteOperateurSource(ope: any) {
    this.compteOperateurSource.next(ope);
  }

  getCertificatSource(): any {
    return of(this.compteOperateurSource);
  }

  setGerantsSource(ger: any[]) {
    this.gerantsSource.next(ger);
  }

  getGerantsSource(): any {
    return of(this.gerantsSource);
  }

  saveCompteOperateur(
    inputObj: SaveCompteOperateurInputVO
  ): Promise<SaveCompteOperateurOutputVO> {
    return this.http
      .httpPost(this.COS_API, JSON.stringify(inputObj))
      .toPromise()
      .then((res) => res as SaveCompteOperateurOutputVO)
      .catch(this.handleError);
  }

  checkExistnaceCompteOperateur(compteOperateur: any): Observable<any> {
    return this.http.httpPost(this.COE_API, compteOperateur);
  }

  getSousCompteSimplifieIfExist(email: any): Observable<any> {
    return this.http.httpPost(this.COESCS_API, email);
  }


  checkIfCompteOperateurEnAttenteDeComplement(
    compteOperateur: any
  ): Observable<any> {
    return this.http.httpPost(this.COC_API, compteOperateur);
  }

  activeCompteOperateur(compteOperateur: any): Observable<any> {
    return this.http.httpPost(this.COA_API, compteOperateur);
  }

  updateCompteOperateur(compteOperateur: any): Observable<any> {
    return this.http.httpPost(this.COU_API, compteOperateur);
  }

  save(compteOperateurVO: any): Observable<any> {
    let result: Observable<Object>;
    if (compteOperateurVO["href"]) {
      result = this.http.httpPut(compteOperateurVO.href, compteOperateurVO);
    } else {
      result = this.http.httpPost(this.COS_API, compteOperateurVO);
    }
    return result;
  }

  updatePassword(compteOperateurVO: any): Observable<any> {
    return this.http.httpPost(this.UPDATE_PASSWORD_API, compteOperateurVO);
  }
  updatePasswordProfil(compteOperateurVO: any): Observable<any> {
    return this.http.httpPost(this.UPDATE_PASSWORDP_API, compteOperateurVO);
  }

  remove(href: string) {
    return this.http.httpDelete(href);
  }

  markAlertAsRead(AlertInputVO: any): Observable<any> {
    return this.http.httpPost(this.flagNotif, AlertInputVO);
  }
  searchReadAlerts(idoperation, pageSize, offset, currentPage) {
    const SearchAlertInputVO = {
      idOperateur: idoperation,
      pageSize: pageSize,
      offset: offset,
      currentPage: currentPage,
    };
    return this.http.httpPost(this.searchHistorique, SearchAlertInputVO);
  }
  findCompteOperateurMfa(compteOperateur: any): Observable<any> {
    return this.http.httpPost(this.CER_MFA_API, compteOperateur);
  }
}
